module.exports = __webpack_public_path__ + "fonts/roboto-v27-latin-ext_latin-900.6bcc133.ttf";